<div class="content">
  <app-mainmenu></app-mainmenu>
</div>
<router-outlet></router-outlet>
<app-footer></app-footer>
